export function normalizeCourseKey(name?: string): string {
  const s = (name || "").trim().toLowerCase();
  if (!s) return "";

  // remove extra spaces
  let x = s.replace(/\s+/g, " ");

  // remove common decorations
  x = x.replace(/\[[^\]]*]/g, "");   // [LEC], [LAB] etc.
  x = x.replace(/\([^)]*\)/g, "");   // (group A) etc.
  x = x.replace(/[-–—]+/g, " ");     // dashes -> space
  x = x.replace(/[|/\\]+/g, " ");    // separators -> space

  // keep letters/digits/space
  x = x.replace(/[^a-z0-9а-яёқғңүұһәі\s]/gi, "");
  x = x.replace(/\s+/g, " ").trim();

  // convert spaces to dash
  x = x.replace(/\s/g, "-");

  // cap length
  if (x.length > 60) x = x.slice(0, 60);

  return x;
}
